import { message, Modal } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import { arrayToTree } from '@/utils/utils';
import { getTenancies, addTenancy, deleteTenancy, updateTenancy, getRoles, getHistory, getRolesByUserId } from '@pages/MvnoMgr/services/tenancy';

export default {
  namespace: 'tenancy',

  state: {
    data: [],
    tenancyHistory: {},
    tenanciesArray: [],
    tenanciesTree: [],
    top: 0,
  },

  effects: {
    *addTenancy({ payload }, { call, put }) {
      const { success, errorMsg } = yield call(addTenancy, payload);
      if (success) {
        message.success(i18n('MULTITENANCYMGR_ADD_MVNO_SUCCESS'));
        yield put({
          type: 'fetchTenacies',
        });
      } else {
        Modal.error({
          title: 'Error',
          content: errorMsg,
          centered: true,
        });
      }
    },

    *deleteTenancy({ payload }, { call, put }) {
      const { success } = yield call(deleteTenancy, payload);
      if (success) {
        message.success(i18n('MULTITENANCYMGR_DEL_MVNO_SUCCESS'));
        yield put({
          type: 'fetchTenacies',
        });
      }
    },

    *updateTenancy({ payload }, { call, put }) {
      const { success } = yield call(updateTenancy, payload);
      if (success) {
        message.success(i18n('MULTITENANCYMGR_MOD_MVNO_SUCCESS'));
        yield put({
          type: 'fetchTenacies',
        });
      }
    },

    *fetchTenacies(_, { call, put }) {
      const { data, success } = yield call(getTenancies);
      if (success) {
        const tenanciesTree = arrayToTree(data, 'spId', 'parentSpId', 'children') || [];
        yield put({
          type: 'save',
          payload: {
            tenanciesArray: data,
            tenanciesTree,
            top: tenanciesTree[0].spId,
          },
        });
      }
    },

    *fetchHistory({ payload }, { call, put }) {
      const { data, success } = yield call(getHistory, payload);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            tenancyHistory: data,
          },
        });
      }
    },

    *fetchRoles({ payload }, { call, put, select }) {
      const { parentSpId, userId, operation, spId } = payload;
      const { tenanciesArray } = yield select(state => state.tenancy);
      const parent = tenanciesArray.find(v => v.spId === parentSpId);
      let res;
      //   if (operation === 'edit') {
      //     if (parentSpId === 0 || spId === 0) {
      //       res = yield call(getRoles);
      //     } else {
      //       if (parent) res = yield call(getRolesByUserId, parent.userId);
      //       else res = yield call(getRolesByUserId, userId);
      //     }
      //   } else {
      //     if (spId === 0) {
      //       res = yield call(getRoles);
      //     } else {
      //       res = yield call(getRolesByUserId, userId);
      //     }
      //   }
      if (operation === 'edit') {
        if (parentSpId === 0 || spId === 0) {
          res = yield call(getRoles);
        } else if (parent) {
          res = yield call(getRolesByUserId, parent.userId);
        } else {
          res = yield call(getRolesByUserId, userId);
        }
      } else if (spId === 0) {
        res = yield call(getRoles);
      } else {
        res = yield call(getRolesByUserId, userId);
      }

      const { data, success } = res;
      if (success) {
        yield put({
          type: 'save',
          payload: {
            roles: data,
          },
        });
      }
    },

    *fetchOwnRoles({ payload }, { call, put }) {
      const { userId } = payload;
      const { data, success } = yield call(getRolesByUserId, userId);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            ownRoles: data,
          },
        });
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
